import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import { pick, omit } from 'helpers/object';
import { LocalizableMessageShape } from 'components/LocalizableMessage/LocalizableMessage';
import { Location } from './Items/Location';
import { SearchBoxNoResults } from './Items/SearchBoxNoResults';
import { SearchBoxField } from './SearchBoxField';
import { getItemNormalizer } from './SearchBox.helpers';
import { LOCATION_TYPES } from './SearchBox.constants';
import { PanelSection } from './PanelSection';
import { Loader } from './Loader';

var itemToString = function itemToString(i) {
  return (i && i.locationName || '').replace(/<[^>]*>/g, '');
};

var locationIconPath = require('../../../../static/design-system/icons/pin.svg');

var messages = defineMessages({
  noMatches: {
    id: 'searchbox.item.noMatches',
    defaultMessage: 'No matches'
  },
  placeholder: {
    id: 'searchbox.locationField.placeholder',
    defaultMessage: 'City, neighborhood'
  },
  searchPrompt: {
    id: 'searchbox.item.searchPrompt',
    defaultMessage: 'Try searching by city or neighborhood'
  }
});
export var LocationFieldUnwrapped = function LocationFieldUnwrapped(props) {
  return React.createElement(SearchBoxField, _extends({}, pick(Object.keys(SearchBoxField.propTypes), props), {
    itemToString: itemToString,
    isClearable: false,
    icon: React.createElement(Isvg, {
      src: locationIconPath
    }),
    placeholder: props.intl.formatMessage(messages.placeholder),
    blurredValue: _typeof(props.blurredValue) === 'object' ? props.intl.formatMessage(props.blurredValue) : props.blurredValue
  }), function (_ref) {
    var getItemProps = _ref.getItemProps,
        highlightedIndex = _ref.highlightedIndex,
        inputValue = _ref.inputValue,
        onPanelScroll = _ref.onPanelScroll;
    var history = props.history,
        intl = props.intl,
        isLoading = props.isLoading,
        onRemoveItem = props.onRemoveItem,
        suggestions = props.suggestions;

    var _ref2 = inputValue ? [suggestions, LOCATION_TYPES.autocomplete] : [history, LOCATION_TYPES.history],
        _ref3 = _slicedToArray(_ref2, 2),
        items = _ref3[0],
        itemType = _ref3[1];

    var normalizer = getItemNormalizer(itemType);
    var hasResults = items && items.length > 0;
    var sectionItems;

    if (isLoading) {
      sectionItems = React.createElement(Loader, null);
    } else if (hasResults) {
      sectionItems = items.map(function (item, index) {
        var normalizedItem = normalizer(item);
        return React.createElement(Location, _extends({}, getItemProps({
          item: normalizedItem,
          key: normalizedItem.place_id,
          searchId: normalizedItem.location_id,
          highlighted: index === highlightedIndex,
          onRemoveClick: onRemoveItem
        }), {
          item: normalizedItem
        }));
      });
    } else {
      var noResultsMessage = inputValue ? intl.formatMessage(messages.noMatches) : intl.formatMessage(messages.searchPrompt);
      sectionItems = React.createElement(SearchBoxNoResults, {
        message: noResultsMessage
      });
    }

    return React.createElement("div", {
      className: "dropdown searchbox__panel",
      onScroll: onPanelScroll
    }, React.createElement("div", {
      className: "dropdown__content"
    }, React.createElement(PanelSection, null, sectionItems)));
  });
};
LocationFieldUnwrapped.propTypes = _objectSpread({
  blurredValue: LocalizableMessageShape,
  isLoading: PropTypes.bool.isRequired,
  onRemoveItem: PropTypes.func.isRequired,
  history: PropTypes.array,
  suggestions: PropTypes.array
}, omit(['prompt', 'itemToString', 'children', 'blurredValue'], SearchBoxField.propTypes));
export var LocationField = injectIntl(LocationFieldUnwrapped);